import showPopup from '@a/components/showPopup'
import LoginOrRegPopup from './loginOrRegPopup.vue'

export default function showLoginOrReg() {
  showPopup(LoginOrRegPopup, {position: 'bottom', style: {height: '66%', backgroundColor: 'var(--theme-primary-dark)'}})
}